<template>
  <div class="student">
    <div class="header">
      <el-card class="box-card">
        <el-row align="middle" type="flex">
          <el-col :span="8">
            <span>网班系统管理员后台</span>
            <el-button
              round
              class="add"
              @click="dialogVisible = true"
              size="small"
              type="primary"
              style="margin-left:10px"
            >
              <i class="el-icon-circle-plus"></i>新增试卷
            </el-button>
          </el-col>
          <el-col :span="8"> </el-col>
          <el-col :span="8">
            <div class="search-rg">
              <el-input
                class="search"
                size="small"
                v-model="search"
                placeholder="搜索试卷名称"
              ></el-input>
              <el-button type="primary" size="small" @click="handleSeach"
                >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div class="dashboard-container">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          label="试卷名称"
          align="center"
          width="220"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>
        <el-table-column label="试卷地址" align="center">
          <template slot-scope="scope">
            <!-- <a :href="address + scope.row.id" target="_blank">{{
              scope.row.id
            }}</a>

            <el-tag
              class="tag-read"
              :data-clipboard-text="address + scope.row.id"
              @click="copy"
              size="small"
              style="margin-left:10px"
              >复制</el-tag
            > -->
            <el-tag
              @click="getAddress(scope.row.id)"
              size="small"
              style="margin-left: 10px"
              >查看</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="试卷说明"
          width="120"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.brief }}</template>
        </el-table-column>
        <el-table-column label="试题数" align="center">
          <template slot-scope="scope">{{ scope.row.num }}</template>
        </el-table-column>
        <el-table-column label="答题人数" align="center">
          <template slot-scope="scope">
            <el-link
              @click="link('LookOver', scope.row.id)"
              type="danger"
              v-if="scope.row.type != 5"
              >{{ scope.row.results_count }}</el-link
            >
          </template>
        </el-table-column>
        <!-- <el-table-column label="正确率" align="center">
          <template class="brief">无</template>
        </el-table-column> -->
        <el-table-column label="试卷类型" align="center">
          <template slot-scope="scope" class="brief">
            <span v-if="scope.row.type == 1">测验卷</span>
            <span v-if="scope.row.type == 2">考试卷</span>
            <span v-if="scope.row.type == 3">测试卷</span>
            <span v-if="scope.row.type == 4">顺序练习</span>
            <span v-if="scope.row.type == 5">个人卷</span>
          </template>
        </el-table-column>
        <el-table-column label="试卷状态" align="center">
          <template slot-scope="scope" class="brief">
            <el-link type="success" v-if="scope.row.status == 0"
              >已开启</el-link
            >
            <el-link type="warning" v-if="scope.row.status == 2"
              >已删除</el-link
            >
            <el-link type="danger" v-if="scope.row.status == 3">已关闭</el-link>
            <el-link type="primary" v-if="scope.row.status == 4"
              >已发布</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="试卷操作" align="center" width="320">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="点击可编辑试卷信息及更换试题"
              placement="top"
            >
              <el-tag
                plain
                type="primary"
                size="small"
                @click="link('EditPaperIndex', scope.row.id)"
                >编辑</el-tag
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="点击可查看该试卷的学生成绩列表"
              placement="top"
            >
              <el-tag
                size="small"
                effect="dark"
                @click="link('LookOver', scope.row.id)"
                >查看</el-tag
              >
            </el-tooltip>
            <el-tag
              type="success"
              size="small"
              @click="link('PaperAnalysis', scope.row.id)"
              >分析</el-tag
            >

            <!-- <el-button plain type="primary" size="mini" @click="handlePaperPublish(scope.row.id)" v-if="scope.row.status!=4">发布</el-button> -->
            <el-tag type="info" size="mini" @click="copyShow(scope.row.id)"
              >复制</el-tag
            >
            <el-tooltip
              class="item"
              effect="dark"
              content="点击后关闭该试卷考试通道，学生将无法进入该试卷"
              placement="bottom"
            >
              <el-tag
                v-if="scope.row.status == 0"
                @click="handlePaperStatus(3, scope.row.id)"
                type="danger"
                size="small"
                effect="dark"
                >关闭</el-tag
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="点击可开启该试卷的考试通道，学生可在考试时间内正常考试"
              placement="bottom"
            >
              <el-tag
                v-if="scope.row.status == 3"
                @click="handlePaperStatus(1, scope.row.id)"
                type="success"
                size="small"
                effect="dark"
                >开启</el-tag
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="点击后该试卷将被删除且不可恢复"
              placement="bottom"
            >
              <el-tag
                type="warning"
                size="small"
                effect="dark"
                @click="handlePaperStatus(2, scope.row.id)"
                >删除</el-tag
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="监考记录" align="center">
          <template slot-scope="scope" class="brief">
            <el-link type="primary" @click="toInvigilateChart(scope.row.id)"
              >查看</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="违规记录" align="center">
          <template slot-scope="scope" class="brief">
            <el-link type="primary" @click="toInvigilate(scope.row.id)"
              >查看</el-link
            >
          </template>
        </el-table-column>
        <!-- <el-table-column label="订单列表" width="100" align="center">
          <template slot-scope="scope" class="brief">
            <el-link type="primary" @click="toOrderList(scope.row.id)"
              >查看</el-link
            >
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="复制试卷" width="100" align="center">
          <template slot-scope="scope" class="brief">
            <el-link type="warning" @click="copyShow(scope.row.id)"
              >复制试卷</el-link
            >
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pages" v-if="total">
        <div class="pages-item">
          <p class="pages-text">
            每页显示{{ pageSize }} 条记录，共 {{ total }}条记录
          </p>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          :total="total"
          class="pages-item"
        ></el-pagination>
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 添加机构 -->
    <el-dialog
      title="新增试卷"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <addPaper @addpaper="addpaper"></addPaper>
    </el-dialog>
    <el-dialog
      title="复制试卷"
      :visible.sync="copyVisible"
      width="400px"
      center
    >
      <p>您确认要复制试卷吗？</p>
      <el-select v-model="localOrg" placeholder="请选择">
        <el-option
          v-for="item in orgData"
          :key="item.number"
          :label="item.name + '(' + item.number + ')'"
          :value="item.number"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyVisible = false">取 消</el-button>
        <el-button type="primary" @click="copyPaper" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="试卷地址"
      :visible.sync="addressVisible"
      width="400px"
      center
    >
      <a :href="address + address_id" target="_blank">
        {{ address }}{{ address_id }}
      </a>
      <span slot="footer">
        <el-button
          class="tag-read"
          type="primary"
          :data-clipboard-text="address + address_id"
          @click="copy"
          >复 制</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import addPaper from '../components/addPaper'
import Clipboard from 'clipboard'
export default {
  name: 'org',
  data() {
    return {
      auth: {},
      title: '',
      search: '',
      tableData: [],
      pageSize: 20,
      total: 0,
      dialogVisible: false,
      dialogVisibleEdit: false,
      copyVisible: false,
      orgData: [],
      search: '',
      page: 1,
      address: '',
      copy_id: '',
      localOrg: '',
      loading: false,
      addressVisible: false,
      address_id: '',
    }
  },
  components: { addPaper },
  created() {
    let _this = this
    _this.getListData()
    let url = window.location.host
    if (url.indexOf('localhost') != -1) {
      _this.address = 'http://' + url + '/entrance/'
    } else {
      _this.address = 'https://' + url + '/entrance/'
    }
    _this.orgData = JSON.parse(localStorage.getItem('orgs'))
  },
  methods: {
    getListData() {
      let _this = this
      this.$http
        .post(process.env.VUE_APP_URL + 'paper', {
          search: _this.search,
          page: _this.page,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data
            _this.total = data.data.total
            _this.current = Math.ceil(_this.total / 1)
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    copy() {
      this.addressVisible = false
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        console.log('复制成功')
        //  释放内存
        //  clipboard.destory()
      })
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持复制')
        // 释放内存
        //  clipboard.destory()
      })
    },
    copyShow(id) {
      this.copy_id = id
      this.copyVisible = true
      this.localOrg = this.Storage.getStorage('orgNumber')
    },
    getAddress(id) {
      this.addressVisible = true
      this.address_id = id
    },
    copyPaper() {
      let _this = this
      _this.loading = true
      this.$http
        .post(process.env.VUE_APP_URL + 'paperCopy', {
          id: _this.copy_id,
          org_number: _this.localOrg,
        })
        .then(function(data) {
          _this.loading = false
          if (data.data.code == 200) {
            _this.$message.success({ message: '复制试卷成功' })
            _this.copyVisible = false
            _this.getListData()
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          _this.loading = false
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },

    link(path, id) {
      this.$router.push({ name: path, params: { id: id } })
    },
    toInvigilateChart(id) {
      this.$router.push({ name: 'invigilateChart', query: { id: id } })
    },
    toInvigilate(id) {
      this.$router.push({
        name: 'invigilate',
        query: { paper_id: id, type: 1 },
      })
    },
    toOrderList(id) {
      this.$router.push({ name: 'orderList', query: { id: id } })
    },
    handleSeach() {
      this.page = 1
      this.getListData()
    },
    addpaper(data) {
      let _this = this
      _this.dialogVisible = false
      if (data) {
        this.$http
          .post(process.env.VUE_APP_URL + 'paperInsert', data)
          .then(function(data) {
            _this.$message.success('新增试卷成功！')
            _this.getListData()
          })
          .catch(function(error) {
            _this.$message.error('网络错误,请刷新界面重试')
            return
          })
      }
    },
    handleCurrentChange(currentPage) {
      let _this = this
      _this.page = currentPage
      _this.getListData()
    },
    toIssure(rowData) {
      this.$confirm('确定要发布该试卷吗', {
        confirmButtonText: '发布',
        cancelButtonText: '取消',
      })
        .then(() => {
          rowData.row.status = 1
        })
        .catch(() => {
          this.$message('已取消发布')
        })
    },
    handlePaperStatus(type, id) {
      let _this = this
      let api = ''
      let str = ''
      switch (type) {
        case 1:
          api = 'paperOpens'
          str = '开启试卷'
          break
        case 2:
          api = 'paperClose'
          str = '关闭试卷'
          break
        case 3:
          api = 'paperShield'
          str = '屏蔽试卷'
          break
      }
      _this
        .$confirm('此操作将' + str + ', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          _this.$http
            .post(process.env.VUE_APP_URL + api, { id: id })
            .then(function(data) {
              if (data.data.code == 200) {
                switch (type) {
                  case 1:
                    _this.$message.success('试卷已开启')
                    break
                  case 2:
                    _this.$message.success('试卷已关闭')
                    break
                  case 3:
                    _this.$message.success('试卷已屏蔽')

                    break
                }
                _this.getListData()
              } else {
                _this.$message.error(data.data.msg)
              }
            })
            .catch(function(error) {
              _this.$message.error({ message: '网络错误,请刷新界面重试' })
              return
            })
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消该操作',
          })
        })
    },
    // closePaper(id) {
    //   let _this = this;
    //   this.$http
    //     .post(process.env.VUE_APP_URL + "paperClose", { id: id })
    //     .then(function(data) {
    //       if (data.data.code == 200) {
    //         _this.$message.success("试卷已关闭");
    //         _this.getListData();
    //       } else {
    //         _this.$message.error(data.data.msg);
    //       }
    //     })
    //     .catch(function(error) {
    //       _this.$message.error({ message: "网络错误,请刷新界面重试" });
    //       return;
    //     });
    // },
    handlePaperPublish(id) {
      let _this = this
      _this
        .$confirm('是否发布该试卷?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          _this.$http
            .post(process.env.VUE_APP_URL + 'paperpushs', { id: id })
            .then(function(data) {
              if (data.data.code == 200) {
                _this.$message.success('试卷已发布')
                _this.getListData()
              } else {
                _this.$message.error('试卷发布失败')
              }
            })
            .catch(function(error) {
              _this.$message.error({ message: '网络错误,请刷新界面重试' })
              return
            })
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消发布',
          })
        })
    },
    shieldPaper(id) {
      let _this = this
      this.$http
        .post(process.env.VUE_APP_URL + 'paperShield', { id: id })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.$message.success('试卷已屏蔽')
            _this.getListData()
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
  },
}
</script>

<style lang="less" scoped>
.el-card__body {
  height: 40px;
  padding: 5px;
  padding-left: 30px;
  line-height: 40px;
}
.pages {
  padding: 10px;
  background-color: #f6f9fc;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    display: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}

.dashboard-container {
  .check {
    cursor: pointer;
    margin: 0 3px;
  }
  .add {
    color: #fb873c;
  }
}

.search {
  width: 240px;
  margin-right: 10px;
}
.el-tag {
  cursor: pointer;
  margin: 4px;
}
</style>
